import React, { useContext } from 'react';
import { useTheme } from '@mui/material/styles';
import { IconProps } from './iconProps';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';

export default function IconExit({
  extColor,
  isAutoscallable = true,
  sizeKey = '24x24',
  onClick,
  style,
}: IconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.primary.main;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      className={cx('icon', 'icon-exit', { 'icon-disabled': !onClick })}
      onClick={onClick}
      style={style}
      width={w}
      height={h}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M18.1392 3.07061C19.251 3.29913 20.1694 4.02861 20.6616 5.07449C20.978 5.74244 20.9692 5.64137 20.9868 8.52853L21 11.1344H16.2276C13.6041 11.1344 11.4596 11.1213 11.4596 11.0993C11.4596 11.0817 11.9342 10.5939 12.5187 10.0139C13.0988 9.43379 13.6129 8.88448 13.6613 8.79659C13.7096 8.69552 13.7448 8.54611 13.7448 8.40988C13.7448 7.82981 13.2086 7.42552 12.6417 7.57493C12.4704 7.61888 12.2506 7.82542 10.5236 9.54365C9.46455 10.6027 8.55929 11.5387 8.51095 11.6266C8.46262 11.7233 8.42746 11.8771 8.42746 12.0133C8.42746 12.1496 8.46262 12.3034 8.51095 12.4C8.55929 12.4879 9.46455 13.424 10.5236 14.483C12.2506 16.2013 12.4704 16.4078 12.6417 16.4517C13.2086 16.6011 13.7448 16.1969 13.7448 15.6168C13.7448 15.4806 13.7096 15.3312 13.6613 15.2301C13.6129 15.1422 13.0988 14.5929 12.5187 14.0128C11.9342 13.4327 11.4596 12.945 11.4596 12.9274C11.4596 12.9054 13.6041 12.8922 16.2276 12.8922H21L20.9868 15.4937C20.9692 18.3853 20.978 18.2842 20.6616 18.9522C20.209 19.919 19.4048 20.6001 18.3721 20.8989L18.0293 21H11.987H5.94459L5.60182 20.8989C4.37577 20.543 3.45733 19.6245 3.10138 18.3985L3.00031 18.0557V12.0133C3.00031 5.27224 2.97833 5.7776 3.30792 5.08328C3.68145 4.28349 4.25712 3.71221 5.04812 3.33868C5.75563 3.0047 5.21072 3.02667 11.8771 3.01788C16.7198 3.01349 17.9063 3.02228 18.1392 3.07061Z" />
    </svg>
  );
}
